import { NETWORK_RECONNECT_TIMEOUT_MS } from './constants';
import type { JanusCallRefs } from './sessionRefs';
import { logJanus } from './utils';

export function clearNetworkReconnectTimeout(r: JanusCallRefs): void {
  if (!r.networkReconnectTimeoutRef.current) return;
  clearTimeout(r.networkReconnectTimeoutRef.current);
  r.networkReconnectTimeoutRef.current = null;
  logJanus('NET', 'cleared 15s reconnect timeout');
}

export function startNetworkReconnectTimeout(
  r: JanusCallRefs,
  isActiveCallSession: () => boolean,
  cancelWebSocketReconnect: () => void,
  source: string
): void {
  if (!isActiveCallSession()) return;
  if (r.networkReconnectTimeoutRef.current) return;

  logJanus('NET', `start 15s timeout (${source})`);
  r.networkReconnectTimeoutRef.current = setTimeout(() => {
    r.networkReconnectTimeoutRef.current = null;
    if (!isActiveCallSession()) return;
    logJanus('NET', '15s reconnect timeout — mạng không phục hồi, kết thúc cuộc gọi');
    r.signalingResyncInFlightRef.current = false;
    r.mediaReconnectPendingRef.current = false;
    r.networkDropPendingRef.current = false;
    r.pendingLocalStreamRefreshRef.current = false;
    r.intentionalWsCloseRef.current = true;
    cancelWebSocketReconnect();
    r.onNetworkReconnectFailedRef.current?.();
  }, NETWORK_RECONNECT_TIMEOUT_MS);
}

export function markNetworkDrop(
  r: JanusCallRefs,
  isActiveCallSession: () => boolean,
  cancelWebSocketReconnect: () => void,
  source: string
): void {
  r.networkDropPendingRef.current = true;
  r.networkBlipAtRef.current = Date.now();
  startNetworkReconnectTimeout(r, isActiveCallSession, cancelWebSocketReconnect, source);
}

export function markNetworkRecovered(r: JanusCallRefs): void {
  r.networkDropPendingRef.current = false;
  clearNetworkReconnectTimeout(r);
}
